import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import moment from 'moment';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

import { useAuth } from '@/api';
import { useLiveGoldPrice } from '@/api/avail-loan/useLiveGoldPrice';
import { useFeatureFlags } from '@/api/feature-flags';
import Transfers from '@/assets/images/icons/24hr-transfers.svg';
import atHome from '@/assets/images/icons/athome.svg';
import business from '@/assets/images/icons/business.svg';
// import branchesIcon from "@/assets/images/icons/branches-icon.svg";
import BuyBack from '@/assets/images/icons/buy-back.svg';
import CompExchangeRates from '@/assets/images/icons/competitive-exchange-rates.svg';
// import customerIcon from "@/assets/images/icons/customer-icon.svg";
import goldBar from '@/assets/images/icons/gold-bar.svg';
import goldRate from '@/assets/images/icons/gold-rate.svg';
import interestRate from '@/assets/images/icons/interest-rate.svg';
import NewHomePageHeroRebranding from '@/assets/images/icons/NewHomePageHeroRebranding.svg';
import primaryCTA from '@/assets/images/icons/Primary-CTA_Large.svg';
import seamlessHome from '@/assets/images/icons/quickapproval.svg';
import rupee from '@/assets/images/icons/Rupee.svg';
import security from '@/assets/images/icons/security.svg';
// import legacyIcon from "@/assets/images/icons/legacy-icon.svg";
import SecurityCompliant from '@/assets/images/icons/security-compliance.svg';
import routes from '@/routes/routes.json';
import useMoengageStore from '@/store/moengage';
import { createMoengageEvent } from '@/utils/moengage';

// import trustDummy4 from '@/assets/images/trust_dummy-4.png';
import { TestimonialCarousel } from './digital-gold';
import { DgPoweredBy } from './digital-gold/landingPage';
import WhyOneMuthoot from './Forex/LandingPage/WhyOneMuthoot';
import AllInOne from './Prelogin/AllInOne';

// TODO: Remove this comment
export const Home = () => {
  const { liveGoldPrice } = useLiveGoldPrice();
  const { featureFlags, isFlagsFetched } = useFeatureFlags();

  const { data: userData } = useAuth();

  const { downloadAppClicked } = useMoengageStore(
    (state) => state.downloadAppClicked
  );

  return (
    <main className="home withHeader">
      <section className="bg bg--dark home__hero position_relative">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h1 className="section__title text--white">
                CHOICE. CONVENIENCE. CREDIBILITY.
              </h1>
              <p className="section__desc text--white">
                Easy Gold Loans | Convenient eSwarna Digital Gold | Hassle-Free
                Forex
              </p>
              <div className="d-flex align-items-center appLinks">
                <Link
                  onClick={() => {
                    createMoengageEvent(downloadAppClicked, {
                      created_date: moment().format('YYYY-MM-DD HH:mm:ss'),
                      mobile_number:
                        userData?.homePhone ||
                        userData?.mobilePhone ||
                        userData?.businessPhone,
                    });
                  }}
                  href="https://qrco.de/mfone"
                  target="_blank"
                  id="home_play-store"
                >
                  <Image
                    style={{ color: undefined }}
                    // className="img-fluid"
                    src={primaryCTA}
                    alt="Google Play Store"
                  />
                  <span className="sr-only">Google Play Store</span>
                </Link>
              </div>
            </div>

            {/* <div className="col-lg-4">
              <Image 
style={{ color: undefined }}
                src={HomePageHero}
                // height={100}
                // width={645}
                style={{
                  // position: "absolute",
                  // zIndex: 0,
                  height: '100%',
                  width:'100%',
                  // top: "-85%",
                  // left: "-20%",
                }}
                alt="download-app"
              />
            </div> */}
          </div>
        </div>
        <Image
          style={{ color: undefined }}
          src={NewHomePageHeroRebranding}
          className="mfone-home-hero-image abs-home_hero"
          alt="download-app"
          loading="eager"
        />
      </section>
      {/* <!-- Nav tabs --> */}
      <section className="home__tab">
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <a
              className="nav-link active"
              data-toggle="tab"
              href="#goldLoans"
              id="home_gold-loans"
            >
              <p className="text--black text--bold title text-center">
                Gold Loans
              </p>
              <p className="text--gray text--regular desc text-center">
                Get instant money with Gold Loans at your convenience
              </p>
            </a>
          </li>
          <li className="nav-item">
            <a
              className="nav-link"
              data-toggle="tab"
              href="#eSwarnaDigitalGold"
              id="home_digital-gold"
            >
              <p className="text--black text--bold title text-center">
                eSwarna Digital Gold
              </p>
              <p className="text--gray text--regular desc text-center">
                Invest in eSwarna Digital Gold, grow your money with minimal
                effort
              </p>
            </a>
          </li>
          {featureFlags.release_ncd && isFlagsFetched && (
            <li className="nav-item">
              <a
                className="nav-link ncd-link"
                data-toggle="tab"
                href="#ncdBonds"
                id="home_digital-gold"
              >
                <p className="text--black text--bold title text-center">NCD</p>
                <p className="text--gray text--regular desc text-center">
                  Invest to get returns of up to 9.81%*
                </p>
              </a>
            </li>
          )}
          <li className="nav-item">
            <a
              className="nav-link"
              data-toggle="tab"
              href="#payBills"
              id="home_pay-bills"
            >
              <p className="text--black text--bold title text-center">Forex</p>
              <p className="text--gray text--regular desc text-center">
                Get cash, multi-currency card or transfer money anytime,
                anywhere
              </p>
            </a>
          </li>
        </ul>

        {/* <!-- Tab panes --> */}
        <div className="tab-content bg bg--light">
          <div className="tab-pane active container" id="goldLoans">
            <div className="row">
              <div className="col-lg-6">
                <div className="tab__content">
                  <p className="text--black text--bold tab__title">
                    {/* <span className="text--yellow">Gold Loans</span> */}
                    Gold Loans whenever you want it, wherever you want it
                  </p>
                  <p className="text--gray text--regular tab__desc">
                    Get no-questions-asked, super secure quick Gold Loans either
                    from the comfort of your home or at any of our 3700+
                    branches across India.
                  </p>
                  <div className="align-items-center tab__button web-view">
                    <Link
                      href="/gold-loans"
                      className="custom__button custom__button--dark"
                      id="home_apply-now"
                    >
                      Apply Now
                    </Link>
                    <Link
                      href="#"
                      className="custom__button custom__link--dark"
                      id="home_learn-more"
                    >
                      Learn more
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="tab__card__container">
                  <div className="item">
                    <div className="tab__card">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        src={atHome}
                        alt="30 minutes door step service"
                      />
                      <p className="text--black text--regular title text-center">
                        <span className="text--bold">Seamless</span> <br /> At
                        Home Service
                        <br />
                        <br />
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="tab__card">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        src={interestRate}
                        alt="lowest interest rate"
                      />
                      <p className="text--black text--regular title text-center">
                        <span className="text--bold">
                          {' '}
                          11.99%* p.a. <br />
                        </span>{' '}
                        (0.99%* p.m.) <br />
                        Low Interest Rates
                      </p>
                    </div>
                  </div>
                </div>
                <div className="tab__card__container">
                  <div className="item mb-md-0">
                    <div className="tab__card">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        src={seamlessHome}
                        alt="lowest interest rate"
                      />
                      <p className="text--black text--regular title text-center">
                        <span className="text--bold">Quick Approval</span>
                        <br />
                        Direct Bank Transfer
                        <br />
                        <br />
                      </p>
                    </div>
                  </div>
                  <div className="item mb-0">
                    <div className="tab__card">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        src={goldRate}
                        alt="gold rate"
                      />
                      <p className="text--black text--regular title text-center">
                        Offered gold rate/ gm up to
                        <span className="text--bold">
                          {' '}
                          ₹{liveGoldPrice}/gm**
                        </span>
                      </p>
                    </div>
                  </div>
                  <p className="text--medium mt-3">
                    *Available only in select cities. T&C applied.
                  </p>
                </div>
                <div className="align-items-center tab__button mobile-view">
                  <Link
                    href="/gold-loans"
                    className="custom__button custom__button--dark"
                    id="home_gl_apply-now"
                  >
                    Apply Now
                  </Link>
                  <Link
                    href={routes.goldLoan}
                    className="custom__button custom__link--dark"
                    id="home_gl_learn-more"
                  >
                    Learn more
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="tab-pane fade container" id="eSwarnaDigitalGold">
            <div className="row justify-content-center">
              <div className="col-lg-6">
                <div className="tab__content">
                  <p className="text--black text--bold tab__title">
                    Start Investing in{' '}
                    {/* <span className="text--yellow">eSwarna Digital Gold</span> */}
                    eSwarna Digital Gold
                  </p>
                  <p className="text--gray text--regular tab__desc">
                    Get started with your eSwarna Digital Gold investment with
                    as low as Re. 1
                  </p>
                  <div className="align-items-center tab__button web-view">
                    <Link
                      href={routes.digitalGoldHome}
                      className="custom__button custom__button--dark"
                      id="home_dg-invest-now"
                    >
                      Invest Now
                    </Link>
                    <a
                      href={routes.digitalGoldHome}
                      className="custom__button custom__link--dark"
                    >
                      Learn more
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="tab__card__container">
                  <div className="item">
                    <div className="tab__card">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        // src={buyGold}
                        src={rupee}
                        alt="buy eSwarna digital gold as low as 1"
                      />
                      <p className="text--black text--regular title text-center">
                        Invest as low as Re.1
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="tab__card">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        // src={automateSavings}
                        src={goldBar}
                        alt="Automate your savings with SIP"
                      />
                      <p className="text--black text--regular title text-center">
                        99.99% pure gold
                      </p>
                    </div>
                  </div>
                </div>
                <div className="tab__card__container">
                  <div className="item mb-md-0">
                    <div className="tab__card om-dg-home-container">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        // src={convertCoin}
                        src={business}
                        alt="Convert to coin and jewellery"
                      />
                      <p className="text--black text--regular title text-center">
                        Sell your eSwarna Digital Gold at market prices
                      </p>
                    </div>
                  </div>
                  <div className="item mb-0">
                    <div className="tab__card">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        // src={sellInstantly}
                        src={security}
                        alt="Sell instantly"
                      />
                      <p className="text--black text--regular title text-center">
                        Stored safely & securely
                      </p>
                    </div>
                  </div>
                </div>
                <div className="align-items-center tab__button mobile-view">
                  <Link
                    href={routes.digitalGoldHome}
                    className="custom__button custom__button--dark"
                    id="home_dg-invest"
                  >
                    Invest Now
                  </Link>
                  <Link
                    href="#"
                    className="custom__button custom__link--dark"
                    id="home_dg-learn-more"
                  >
                    Learn more
                  </Link>
                </div>
              </div>
              <div className="mt-4">
                <DgPoweredBy />
              </div>
            </div>
          </div>

          <div className="tab-pane fade container" id="ncdBonds">
            <div className="row">
              <div className="col-lg-6">
                <div className="tab__content">
                  <p className="text--black text--bold tab__title">
                    Benefits of <br />
                    NCD
                  </p>
                  <p className="text--gray text--regular tab__desc">
                    Build your investment portfolio with as low as Rs. 10,000
                    and get high returns of up to 9.81%*
                  </p>
                  <div className="align-items-center tab__button web-view">
                    <Link
                      href={routes.ncdApply}
                      className="custom__button custom__button--dark"
                      id="home_dg-invest-now"
                    >
                      Get Started
                    </Link>
                    {/* <a
                      href={routes.digitalGoldHome}
                      className="custom__link custom__link--dark"
                    >
                      Learn more
                    </a> */}
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="tab__card__container">
                  <div className="item">
                    <div className="tab__card">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        // src={buyGold}
                        src={rupee}
                        alt="buy eSwarna digital gold as low as 1"
                      />
                      <p className="text--black text--bold title text-center">
                        No KYC
                      </p>
                      <p className="text--black text--regular title text-center">
                        Fasttrack your investments
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="tab__card">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        // src={automateSavings}
                        src={goldBar}
                        alt="Automate your savings with SIP"
                      />
                      <p className="text--black text--bold title text-center">
                        Financial Stability
                      </p>
                      <p className="text--black text--regular title text-center">
                        High-yeild low-risk investment
                      </p>
                    </div>
                  </div>
                </div>
                <div className="tab__card__container">
                  <div className="item mb-md-0">
                    <div className="tab__card">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        // src={convertCoin}
                        src={business}
                        alt="Convert to coin and jewellery"
                      />
                      <p className="text--black text--bold title text-center">
                        Easy Investment
                      </p>
                      <p className="text--black text--regular title text-center">
                        Hassle-free process
                        <br />
                        <br />
                      </p>
                    </div>
                  </div>
                  <div className="item mb-0">
                    <div className="tab__card">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        // src={sellInstantly}
                        src={security}
                        alt="Sell instantly"
                      />
                      <p className="text--black text--bold title text-center">
                        Flexible Tenure
                      </p>
                      <p className="text--black text--regular title text-center">
                        Durations thats suits your needs
                      </p>
                    </div>
                  </div>
                </div>
                <div className="align-items-center tab__button mobile-view">
                  <Link
                    href={routes.ncdApply}
                    className="custom__button custom__button--dark"
                    id="home_dg-invest"
                  >
                    Get Started
                  </Link>
                  {/* <Link
                    href="#"
                    className="custom__link custom__link--dark"
                    id="home_dg-learn-more"
                  >
                    Learn more
                  </Link> */}
                </div>
              </div>
            </div>
          </div>

          <div className="tab-pane fade container" id="payBills">
            <div className="row">
              <div className="col-lg-6">
                <div className="tab__content">
                  <p className="text--black text--bold tab__title">
                    Forex Made Simple
                  </p>
                  <p className="text--gray text--regular tab__desc">
                    Get forex securely and reliably with competitive exchange
                    rates. Enjoy hassle-free international money transfers.
                  </p>
                  <div className="align-items-center tab__button web-view">
                    <Link
                      href="/forex"
                      className="custom__button custom__button--dark"
                      id="home_forex-book-now"
                    >
                      Book Now
                    </Link>
                    <Link
                      href="/forex"
                      className="custom__button custom__link--dark"
                      id="home_forex-learn-more"
                    >
                      Learn more
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="tab__card__container">
                  <div className="item">
                    <div className="tab__card">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        src={SecurityCompliant}
                        alt="100% Secure
                        Transactions"
                      />
                      <p className="text--black text--regular title text-center">
                        <span className="text--bold">100%</span> Secure
                        Transactions
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="tab__card">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid mfone-CompExchangeRates"
                        src={CompExchangeRates}
                        alt="Competitive Exchange Rates"
                      />
                      <p className="text--black text--regular title text-center">
                        <span className="text--bold">Competitive </span>Exchange
                        Rates
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="tab__card">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        src={Transfers}
                        alt="24 hour* transfers guaranteed"
                      />
                      <p className="text--black text--regular title text-center">
                        <span className="text--bold">24 hour*</span> transfers
                        guaranteed
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="tab__card">
                      <Image
                        style={{ color: undefined }}
                        className="img-fluid"
                        src={BuyBack}
                        alt="Buy-back guarantee"
                      />
                      <p className="text--black text--regular title text-center">
                        <span className="text--bold">Buy-back</span> <br />{' '}
                        guarantee
                      </p>
                    </div>
                  </div>
                </div>
                <div className="align-items-center tab__button mobile-view">
                  <Link
                    href="/forex"
                    className="custom__button custom__button--dark"
                    id="home_forex_mbl-book"
                  >
                    Book Now
                  </Link>
                  <Link
                    href="/forex"
                    className="custom__button custom__link--dark"
                    id="home_forex_mbl-learn"
                  >
                    Learn more
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <WhyOneMuthoot />

      <section className="bg bg--light">
        <div className="home__customer font-helvetica-neue">
          <div className="container">
            <h2 className="section__title-small text--bold text--black text-center">
              The Customer Is Always Right
            </h2>
            <p className="section__desc text--gray text-center">
              Our customers have experienced our commitment to serving them. You
              can, too.
            </p>
          </div>
          <div className="home__customer--slider">
            <TestimonialCarousel />
          </div>
        </div>
      </section>

      <AllInOne />

      <section className="home__faq with-padding">
        <div className="container">
          <h2 className="section__title-small text--black text--bold">
            Frequently Asked Questions
          </h2>
          <div className="faq">
            <div
              className="faq__header collapsed"
              data-toggle="collapse"
              data-target="#question_1"
            >
              <p>What is a Gold Loan from Home? </p>
              <span></span>
            </div>
            <div className="faq__answer collapse" id="question_1">
              <p>
                A Gold Loan from Home is a service where you can get a Gold Loan
                at your home, unlike the traditional Gold Loan where you visit a
                Bank or an NBFC. We process your Gold Loan at your home
                seamlessly. Our loan managers will carry your gold jewellery
                safely to a nearby Muthoot FinCorp branch, so you don’t have to
                worry about traveling with your gold jewellery. <br />{' '}
                **Available in selected cities
              </p>
            </div>
          </div>
          <div className="faq">
            <div
              className="faq__header collapsed"
              data-toggle="collapse"
              data-target="#question_2"
            >
              <p>What are the benefits of getting a Gold Loan from Home? </p>
              <span></span>
            </div>
            <div className="faq__answer collapse" id="question_2">
              <p>
                When you book an appointment for a Gold Loan from Home, we come
                to your home to collect the gold jewellery at your preferred
                date and time, making the process easy, hassle-free, and
                seamless. Additionally, we carry your pledged gold jewellery to
                a nearby Muthoot FinCorp branch in a GPS-tracked safe locker, so
                you don’t have to carry it yourself. Your pledged gold jewellery
                is automatically insured as an added layer of protection.
              </p>
            </div>
          </div>
          <div className="faq">
            <div
              className="faq__header collapsed"
              data-toggle="collapse"
              data-target="#question_3"
            >
              <p>What is eSwarna Digital Gold?</p>
              <span></span>
            </div>
            <div className="faq__answer collapse" id="question_3">
              <p>
                eSwarna Digital Gold is the virtual method of buying and
                investing in gold without having to physically hold the gold.
                When you buy eSwarna Digital Gold on Muthoot FinCorp ONE
                platform, the corresponding physical gold is stored at secure
                vaults by Muthoot EXIM appointed custodian Sequel Logistics
                completely free of cost.
                <br />
                Your gold is always 100% safe and secure at no extra cost.
              </p>
            </div>
          </div>
          {/* <div className="faq">
            <div
              className="faq__header collapsed"
              data-toggle="collapse"
              data-target="#question_4"
            >
              <p>What is the Purity of Gold?</p>
              <span></span>
            </div>
            <div className="faq__answer collapse" id="question_4">
              <p>
                Muthoot EXIM offers 999 fineness also known as 24 karat purity
                through Muthoot FinCorp ONE platform.
              </p>
            </div>
          </div> */}
          {/* <div className="faq">
            <div
              className="faq__header collapsed"
              data-toggle="collapse"
              data-target="#question_5"
            >
              <p>How can I exchange my eSwarna Digital Gold for Physical Jewellery?</p>
              <span></span>
            </div>
            <div className="faq__answer collapse" id="question_5">
              <p>
                Digital gold is a form of electronic money based on mass units
                of gold. It is a kind of representative money, like a US paper
                gold certificate at the time that these were exchangeable for
                gold on demand
              </p>
            </div>
          </div> */}
          {/* <div className="faq">
            <div
              className="faq__header collapsed"
              data-toggle="collapse"
              data-target="#question_6"
            >
              <p>Why is the buy and sell price different on the same day?</p>
              <span></span>
            </div>
            <div className="faq__answer collapse" id="question_6">
              <p>
                Digital gold is a form of electronic money based on mass units
                of gold. It is a kind of representative money, like a US paper
                gold certificate at the time that these were exchangeable for
                gold on demand
              </p>
            </div>
          </div> */}
        </div>
      </section>
    </main>
  );
};
